export const APP_URL = `https://backend.staging.cjh.agifly.cloud`;
// export const APP_URL = `http://localhost:3000`;
export const API_URL = `${APP_URL}/api/v1`;
export const FILE_BASE_URL = 'https://backend.staging.cjh.agifly.cloud';
// export const FILE_BASE_URL = 'http://localhost:3000';

export const NODE_ENV = "developemnt"
// export const NODE_ENV = "production"